export const REGEX = {
  phone: /^[6-9]\d{9}$/,                                  // 10-digit Indian mobile
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  gstin: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  pan: /^[A-Z]{5}\d{4}[A-Z]{1}$/,
  ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  bankAccount: /^\d{9,18}$/,
  upi: /^[\w.\-]{2,256}@[a-zA-Z]{2,64}$/,
};

// rules = { fieldName: { label, required, regex, hint } }
export function validateFields(form, rules) {
  const errors = [];
  for (const [field, rule] of Object.entries(rules)) {
    const val = String(form[field] ?? "").trim();
    if (!val) {
      if (rule.required) errors.push(`${rule.label} is required`);
      continue;
    }
    if (rule.regex && !rule.regex.test(val)) {
      errors.push(`${rule.label} is invalid${rule.hint ? " (" + rule.hint + ")" : ""}`);
    }
  }
  return errors;
}
